import React, { useEffect, useState } from 'react';
// import { Box, Typography, IconButton} from '@material-ui/core';
import { Box, Typography, Divider, IconButton } from '@material-ui/core';
import CustomModal from '../../eir-porting/CustomModal/CustomModal';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import EsimInfoModal from './EsimInfoModal';
import EsimReplacementModal from './EsimReplacementModal';
import useStyles from './style';
import MyEirSimReplacementContainer from './MyEirSimReplacementContainer';
import simIcon from '../images/SIM.png';
import eSimIcon from '../images/eSIM.png';

const OrderReplacementSimModal = ({
    linkName,
    getSimEligibilityResponse,
    ContactDetails,
    serviceId,
    simCost,
    flag,
    simCardType,
}) => {
    const classes = useStyles();
    const [open, setOpenModal] = useState(false);
    const [showESIMReplacementModal, setshowESIMReplacementModal] = useState(false);
    const [showPSIMReplacementModal, setshowPSIMReplacementModal] = useState(false);
    const backArrowAction = () => {
        setOpenModal(!open);
        setshowESIMReplacementModal(false);
    };
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const handleOpen = () => {
        setOpenModal(true);
    };
    return (
        <>
            <Box id='sim-replacement'>
                <Typography
                    component='a'
                    onClick={handleOpen}
                    className={classes.esimInfoLink}
                    aria-label='Order your replacement SIM (Choose SIM type)'
                    href='#'
                    role='link'
                    tabIndex={0}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === '') {
                            e.preventDefault();

                            handleOpen();
                        }
                    }}
                >
                    {linkName}
                </Typography>

                <CustomModal
                    open={open}
                    toggle={backArrowAction}
                    header={{
                        text: 'Order a replacement SIM',
                        arrowAction: backArrowAction,
                        ariaLabel: 'Back to Manage SIM & eSIM',
                        center: false,
                    }}
                    description='Choose your SIM type'
                    cta1={cta1}
                    cta2={cta2}
                    ariaLabel='Order a replacement SIM opens popup'
                >
                    <Box className={classes.orderSIMContainer}>
                        <Typography variant='h6' className={classes.helperText}>
                            Choose your SIM type
                        </Typography>

                        <Box className={classes.simOption}>
                            <Box className={classes.simInfoContainer}>
                                <Box
                                    component='img'
                                    src={simIcon}
                                    alt=''
                                    className={classes.simIconContainer}
                                />
                                <Box className={classes.simTextContainer}>
                                    <Typography variant='subtitle2' className={classes.simTitle}>
                                        Physical SIM
                                    </Typography>
                                    <Typography variant='body2' className={classes.simSubtitle}>
                                        Delivered in 2-3 working days. Just insert the SIM and
                                        you’re good to go.
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={classes.arrowIcon}>
                                <IconButton
                                    className={classes.simArrow}
                                    onClick={() => setshowPSIMReplacementModal(true)}
                                    aria-label='Select Physical SIM'
                                    role='button'
                                    tabIndex={0}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === '') {
                                            e.preventDefault();

                                            setshowPSIMReplacementModal(true);
                                        }
                                    }}
                                >
                                    <ArrowForwardIosIcon fontSize='small' />
                                </IconButton>
                            </Box>
                        </Box>

                        {/* Removing eSIM selection option as part of CR - 7479 */}
                        {/* <Divider className={classes.simDivider} />

                        <Box className={classes.simOption}>
                            <Box className={classes.simInfoContainer}>
                                <Box
                                    component='img'
                                    src={eSimIcon}
                                    alt=''
                                    className={classes.simIconContainer}
                                />
                                <Box className={classes.simTextContainer}>
                                    <Box display='inline-flex' alignItems='center'>
                                        <Typography
                                            variant='subtitle2'
                                            className={classes.esimTitle}
                                        >
                                            eSIM
                                        </Typography>
                                        <EsimInfoModal />
                                    </Box>
                                    <Typography variant='body2' className={classes.simSubtitle}>
                                        Quick and easy install, the QR code for eSIM activation will
                                        be available in the app.
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={classes.arrowIcon}>
                                <IconButton
                                    className={classes.simArrow}
                                    onClick={() => setshowESIMReplacementModal(true)}
                                    aria-label='Select eSIM'
                                    role='button'
                                >
                                    <ArrowForwardIosIcon fontSize='small' />
                                </IconButton>
                            </Box>
                        </Box> */}
                    </Box>
                </CustomModal>
            </Box>
            {showESIMReplacementModal && (
                <EsimReplacementModal
                    showESIMReplacementModal={showESIMReplacementModal}
                    setshowESIMReplacementModal={setshowESIMReplacementModal}
                    simCardType={simCardType}
                    setcloseOrderSimModal={setOpenModal}
                    serviceId={serviceId}
                />
            )}
            {showPSIMReplacementModal && (
                <MyEirSimReplacementContainer
                    linkName={'Order'}
                    getSimEligibilityResponse={getSimEligibilityResponse}
                    ContactDetails={ContactDetails}
                    serviceId={serviceId}
                    simCost={simCost}
                    flag={flag}
                    showPSIMReplacementModal={showPSIMReplacementModal}
                    setshowPSIMReplacementModal={setshowPSIMReplacementModal}
                />
            )}
        </>
    );
};
export default OrderReplacementSimModal;
